import * as React from 'react';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { Props as IReactSelectProps } from 'react-select/lib/Select';

import './styles.scss';

export interface ISelectOptionType {
  label: string;
  value: string;
}

const Select: React.FunctionComponent<IReactSelectProps> = ({ className, ...props }) => {
  const cn = classNames('Select', className);
  return <ReactSelect className={cn} classNamePrefix="Select" {...props} />;
};

export default React.memo(Select);



// WEBPACK FOOTER //
// ./src/components/Select/index.tsx